import { render } from "./more_items.vue?vue&type=template&id=552ba20b"
import script from "./more_items.vue?vue&type=script&lang=js"
export * from "./more_items.vue?vue&type=script&lang=js"

import "./more_items.vue?vue&type=style&index=0&id=552ba20b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__